<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <Notifications />

      </div>
      <div class="col-md-6">
        <div class="card-body card mb-3">
          <h5 class="card-title">Projekti z nepolnim komisionom</h5>
          <ul>
            <li v-for="p in projectsWithIncompleteCommissions" class="mt-1">
              <router-link :to="{ name: 'Project', params: { projectId: p.id } }">{{ p.fullName }}</router-link>
            </li>
          </ul>
          <p v-show="projectsWithIncompleteCommissions.length === 0">Ni projektov z nepoplnim komisionom.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <ProjectsCard class="card mb-3" :itemsPerPage="20" subTitle="Vsi" />
      </div>
      <div class="col-md-3">
        <ProjectsCard class="card mb-3" statuses="ActiveReview" subTitle="Za pregledat" />
      </div>
      <div class="col-md-3">
        <InternalOrdersCard class="card mb-3"
          title="ToDo"
          internalOrderTypes="ToDo"
          subTitle="Accepted, zame"
          :ownerID="worker.id.value"
          statuses="Accepted"
          v-if="worker.id.value" />
        <ServiceOrdersCard class="card mb-3"
          title="Servisni nalogi"
          subTitle="Triage,Accepted,InProgress + zame"
          statuses="Triage,Accepted,InProgress"
          :ownerID="worker.id.value" />
      </div>
      <div class="col-md-3">
        <ServiceOrdersCard class="card mb-3"
          title="Servisni nalogi"
          subTitle="Offer"
          statuses="Offer"
          :itemsPerPage=10 />

        <DevicesCard class="card mb-3" />

      </div>
    </div>


  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject, onUnmounted } from "vue"
import { useWorker } from "../composition-api/useWorker"
import { useAuth } from "../composition-api/useAuth"
import FacilitiesCard from "../components/FacilitiesCard.vue"
import InternalOrdersCard from "../components/InternalOrdersCard.vue"
import WarehouseTransfersCard from "../components/WarehouseTransfersCard.vue"
import WorkersCard from "../components/WorkersCard.vue"
import Notifications from "../components/Notifications.vue"
import ProjectsCard from "../components/ProjectsCard.vue"
import ServiceOrdersCard from "../components/ServiceOrdersCard.vue"
import { listEntitiesAsync } from "../api"

defineOptions({ name: "HomeLeaderProjects" })

const { fetchAuthAsync } = useAuth()
const { worker } = useWorker()
const workersCardEl = ref(null)

const projectsWithIncompleteCommissions = ref([])

onMounted(async () => {
  projectsWithIncompleteCommissions.value = await listEntitiesAsync(
    fetchAuthAsync,
    "IncompleteCommissions/Projects",
  )
})
</script>
